<template>
    <div id="results">
        <v-container class="justify-center">
            <v-row class="justify-center">
                <h1>Tabele Wyników</h1>
            </v-row>
            <v-row class="justify-center" v-for="(item,index) in leagues" :key="index">
                <h2>{{item.leagueName}} ({{ item.leagueId }})</h2>
                <v-col cols="12" sm="12">
                    <v-expansion-panels multiple>
                        <v-expansion-panel v-for="race in leagues[item.leagueId].races" :key="race.raceId">
                            <v-expansion-panel-header>{{ race.raceName }} ({{ race.raceId }})</v-expansion-panel-header>
                            <v-expansion-panel-content v-if="leagues[item.leagueId].races[race.raceId].results != ''">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                            <th class="text-left">Miejsce</th>
                                            <th class="text-left">Nick</th>
                                            <th class="text-left">Numer Startowy</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="places in leagues[item.leagueId].races[race.raceId].results" :key="places.place">
                                            <td>{{ places.place }}</td>
                                            <td>{{ places.nick }}</td>
                                            <td>{{ places.number }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content v-else>
                                <h3>Wyścig się jeszcze nie odbył</h3>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name:'results',
    data(){
        return{
            drivers:[
                {id:0,nick:"Tomaszol",number:1},
                {id:10,nick:"Dariuszo",number:2},
                {id:13,nick:"Roberto",number:3},
            ]
        }
    },
    computed:{
        leagues(){
            return this.$store.state.leagues;
        }
    }
}
</script>